import { Locale } from 'modules/i18n';

export const referralCodeDialogTranslation = {
  [Locale.en]: {
    title: 'Referral code',
  },
};
